import ActivityPage from "client/components/pages/Activity";

export default ActivityPage;
